"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _iconsReact = require("@carbon/icons-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./sass/InputAddNewOption.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var InputAddNewOptions = function InputAddNewOptions(_ref) {
  var optionsProp = _ref.optionsProp,
      setState = _ref.setState,
      placeholder = _ref.placeholder,
      placeholderAdd = _ref.placeholderAdd;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = (0, _react.useState)('2px'),
      _useState4 = _slicedToArray(_useState3, 2),
      inputWidth = _useState4[0],
      setInputWidth = _useState4[1];

  var handleFocus = function handleFocus() {
    setFocus(true);
  };

  var handleDrop = function handleDrop() {
    setFocus(!focus);
  };

  var _useState5 = (0, _react.useState)(optionsProp),
      _useState6 = _slicedToArray(_useState5, 2),
      options = _useState6[0],
      setOptions = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      search = _useState8[0],
      setSearch = _useState8[1];

  var handleChange = function handleChange(e) {
    var value = e.target.value;
    setSearch(value);
    setInputWidth((value.length + 1) * 8 + 'px');
  };

  var filtered = options.filter(function (item) {
    return item.toLowerCase().includes(search.toLowerCase());
  });

  var _useState9 = (0, _react.useState)([]),
      _useState10 = _slicedToArray(_useState9, 2),
      selections = _useState10[0],
      setSelections = _useState10[1];

  var addChip = function addChip(item) {
    if (!selections.includes(item)) {
      setSelections([].concat(_toConsumableArray(selections), [item]));
      setState([].concat(_toConsumableArray(selections), [item]));
    }
  };

  var removeChip = function removeChip(item) {
    var removing = selections.filter(function (chip) {
      return chip !== item;
    });
    setSelections(removing);
    setState(removing);
  };

  var _useState11 = (0, _react.useState)(''),
      _useState12 = _slicedToArray(_useState11, 2),
      newValue = _useState12[0],
      setNewValue = _useState12[1];

  var handleNewValue = function handleNewValue(e) {
    setNewValue(e.target.value);
  };

  var addNewValue = function addNewValue() {
    if (!options.includes(newValue)) {
      setOptions([].concat(_toConsumableArray(options), [newValue]));
    }

    addChip(newValue);
    setNewValue('');
  };

  var handleEnter = function handleEnter(e) {
    if (e.charCode === 13) {
      if (!options.includes(newValue)) {
        setOptions([].concat(_toConsumableArray(options), [newValue]));
      }

      addChip(newValue);
      setNewValue('');
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", {
    className: "inputNewValue",
    "data-testid": "inputNewValue"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "inputNewValue-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "inputNewValue-chips"
  }, selections.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "inputNewValue-chips-item",
      key: item
    }, /*#__PURE__*/_react.default.createElement("span", null, item), /*#__PURE__*/_react.default.createElement(_iconsReact.Close24, {
      onClick: function onClick() {
        return removeChip(item);
      },
      "data-testid": "removeChip"
    }));
  })), /*#__PURE__*/_react.default.createElement("input", {
    className: "inputNewValue-input",
    style: {
      width: inputWidth
    },
    type: "text",
    placeholder: placeholder,
    onKeyDown: handleFocus // onFocus={handleDrop}
    ,
    onChange: handleChange,
    "datatest-id": "updateInput"
  }))), /*#__PURE__*/_react.default.createElement(_iconsReact.ChevronDown32, {
    className: "inputNewValue-icon ".concat(focus && 'inputNewValue-icon-active'),
    onClick: handleDrop,
    focusable: true
  })), focus && /*#__PURE__*/_react.default.createElement("div", {
    className: "optionBox"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "optionBox-list"
  }, filtered.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("li", {
      tabIndex: "0",
      key: item,
      className: "optionBox-list-item ".concat(selections.includes(item) && 'optionBox-list-item-selected'),
      onClick: function onClick() {
        return addChip(item);
      }
    }, item);
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "optionBox-handler"
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "optionBox-handler-input",
    placeholder: placeholderAdd,
    type: "text",
    value: newValue,
    onChange: handleNewValue,
    onKeyPress: handleEnter,
    "data-testid": "addOptionInput"
  }), /*#__PURE__*/_react.default.createElement("button", {
    "data-testid": "addOptionButton",
    className: "optionBox-handler-button",
    onClick: function onClick() {
      return addNewValue();
    }
  }, "+ Add"))));
};

InputAddNewOptions.propTypes = {
  optionsProp: _propTypes.default.array,
  setState: _propTypes.default.func,
  placeholder: _propTypes.default.string
};
var _default = InputAddNewOptions;
exports.default = _default;